import { Bell, Crown, LockOpen, type LucideIcon } from "lucide-react";

import { useScreen0Language } from "@/features/language";
import { getTranslations } from "@/i18n";

import { EmphasisText } from "../EmphasisText";

import { BenefitsWaveDivider } from "./BenefitsWaveDivider";
import { TrialCalendarTile } from "./TrialCalendarTile";

const TRIAL_ICONS: LucideIcon[] = [LockOpen, Bell, Crown];

export function TrialReassuranceSlide() {
  const { languageCode } = useScreen0Language();
  const t = getTranslations(languageCode);

  return (
    <div className="flex flex-1 flex-col gap-6 pb-4 pt-1">
      <h1 className="text-center text-xl font-semibold leading-snug text-[oklch(90%_0.02_150)] sm:text-[1.35rem]">
        <EmphasisText text={t.onboarding.trialHeadline} />
      </h1>

      <BenefitsWaveDivider variant="trial" />

      <ul className="flex flex-col gap-5">
        {t.onboarding.trialRows.map((row, index) => {
          const Icon = TRIAL_ICONS[index];

          return (
            <li key={row.dayLabel} className="flex gap-3.5">
              <TrialCalendarTile dayLabel={row.dayLabel} icon={Icon} />

              <div className="min-w-0 flex-1">
                <p className="font-semibold leading-snug text-[oklch(90%_0.02_150)]">
                  {row.title}
                </p>
                <p className="mt-1 text-sm leading-relaxed text-[oklch(72%_0.025_155)]">
                  {row.subtitle}
                </p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
